import React from 'react';
import { MenuItem, MenuItemProps, forwardRef } from '@chakra-ui/react';

const DropdownItem = forwardRef<MenuItemProps, React.FC>((props, ref) => (
  <MenuItem iconSpacing="8px" ref={ref} {...props} />
));

export default DropdownItem;
